export default {
    name: "Refresh",
    title: "Refresh",
    icon: "mdi-file-refresh-outline",
    create() {
        return {
            name: this.title,
            description: null,
            actionType: this.name,
            component: null,
        };
    },
};